import { Component, input } from '@angular/core';

@Component({
  selector: 'app-wrong-guess-toast',
  imports: [],
  templateUrl: './wrong-guess-toast.html',
  styleUrl: './wrong-guess-toast.scss',
})
export class WrongGuessToast {
  readonly visible = input(false);
}
